import { updatePatientAllergiesAndConditions } from "../../../../api/clinic/patientApi.js";

export const updatePatientProfile = async (consultationData, getStepDraft) => {
  const patientOverviewDraft = getStepDraft("patientOverview", null);
  
  if (!patientOverviewDraft || !consultationData?.patientId) {
    return;
  }

  const allergies = patientOverviewDraft.allergies || [];
  const conditions = patientOverviewDraft.conditions || [];
  
  // Only update if there's data to save
  if (allergies.length === 0 && conditions.length === 0) {
    return;
  }

  try {
    const updatePayload = {
      allergies: allergies,
      chronicconditions: conditions,
    };
    
    await updatePatientAllergiesAndConditions(consultationData.patientId, updatePayload);
  } catch (profileErr) {
    console.error("Failed to update patient allergies/conditions:", profileErr);
    throw new Error("Failed to update patient profile");
  }
};
